require('./brokerRightsCashExchange.scss');
require('./brokerRightsCashExchangeSidebar/brokerRightsCashExchangeSidebar.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const trim = require('lodash/string/trim');
const moment = require('moment');
const Immutable = require('immutable');
// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { FormattedText } = require('core/i18n').i18n;
// @Components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const BrokerRightsCashExchangeStep1 = require('./brokerRightsCashExchangeSteps/brokerRightsCashExchangeStep1/brokerRightsCashExchangeStep1');
const BrokerRightsCashExchangeStep2 = require('./brokerRightsCashExchangeSteps/brokerRightsCashExchangeStep2/brokerRightsCashExchangeStep2');
const BrokerRightsCashExchangeSidebar = require('./brokerRightsCashExchangeSidebar/brokerRightsCashExchangeSidebar');
const BrokerRightsCashExchangeSucess = require('./brokerRightsCashExchangeSuccess/brokerRightsCashExchangeSuccess');
//@commons
const { OKLink } = require('commonsComponents/OKLink');
//@contactCenter
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const RightsChashExchangeLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/rightsCashExchangeLegalConfirmation/rightsCashExchangeLegalConfirmation');
// @Constans
const {
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    DATE_FORMAT_API,
    BROKER_ORDER_TYPE_CASH_EXCHANGE,
    BROKER_CORPORATE_OPERATIONS_CASH_EXCHANGE_PRODUCT_TYPE
} = require('constants/index');

class BrokerRightsCashExchange extends React.Component {
    constructor(props) {
        super(props);

        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
    }

    handleLegalYesNoOptionChange(value) {
        const { setLegalOptionChange } = this.props;

        setLegalOptionChange(value);
    }

    getPrecontractualMailParams() {
        const { immProfileFields, immBrokerRightsCashExchange } = this.props;

        const controlDigit = trim(immBrokerRightsCashExchange.getIn(['selectedContract','cuenta','digitodecontrol']));
        const productNumber = trim(immBrokerRightsCashExchange.getIn(['selectedContract','contract','product']));
        const contractNumber = trim(immBrokerRightsCashExchange.getIn(['selectedContract','contract','product']));
        const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
        const owner = trim(immBrokerRightsCashExchange.getIn(['selectedContract','contract','owner']));
        const momentEndDate = moment(immBrokerRightsCashExchange.getIn(['selectedOperation', 'endDate']));

        return {
            productKID: '',
            contract: '',
            marketingReport: '',
            infoCcv: '',
            idOrder: '',
            market: '',
            termValidity: momentEndDate.format(DATE_FORMAT_API),
            holders: owner,
            leafletSusbcription: trim(immBrokerRightsCashExchange.getIn(['selectedOperation','linkTriptico'])),
            cnmvDocumentation: trim(immBrokerRightsCashExchange.getIn(['selectedOperation','linkCNMV'])),
            ccv: idContract,
            ccc: '',
            idContract: idContract,
            email: trim(PersonalDataHelper.getEmail(immProfileFields)),
            clientAlias: trim(immProfileFields.get('nombreCliente')),
            isin: trim(immBrokerRightsCashExchange.getIn(['selectedOperation', 'isin'])),
            isinDescribe: trim(immBrokerRightsCashExchange.getIn(['selectedOperation', 'descriptionValue'])),
            orderType: BROKER_ORDER_TYPE_CASH_EXCHANGE,
            productType: BROKER_CORPORATE_OPERATIONS_CASH_EXCHANGE_PRODUCT_TYPE,
            sharesNumber: '',
            sharesAmount: '',
            orderCondition: '',
            conditionPrize : '',
            currency: ' ',
            mifidWarningText: '',
            dateTime: '',
        };
    }

    builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) {
        const {
            immBrokerRightsCashExchange,
            immProfileFields,
            immPreContractualMail,
            immCorporatesOperations,
            currency,
            sendPreContractualMail,
            resetPrecontractualMail,
            selectedLegalConfirmationValue,
            requestProfile,
        } = this.props;

        return (
            <RightsChashExchangeLegalConfirmation
                immBrokerRightsCashExchange={immBrokerRightsCashExchange}
                immCorporatesOperation={immCorporatesOperations}
                currency={currency}
                legalinformationLinks={[bookletLabel, CNMVLabel]}
                immPreContractualMail={immPreContractualMail}
                sendMail={sendPreContractualMail}
                sendMailParams={this.getPrecontractualMailParams()}
                resetMailState={resetPrecontractualMail}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                selectedYesNoOption={selectedLegalConfirmationValue}
                onYesNoOptionChange={this.handleLegalYesNoOptionChange}
            />
        );
    }

    buildWizard() {
        const {
            immBrokerRightsCashExchange,
            onCancel,
            onChangeRightsQuantity,
            onFinish,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onChangeManifest,
            setDocumentsRead
        } = this.props;
        const loading = immBrokerRightsCashExchange.get('isFetching');
        let immSteps = immBrokerRightsCashExchange.get('steps');
        const immStep1 = immSteps.get(FIRST_STEP);
        const firstStepIsLoading = immStep1.get('isFetching');
        let visibleStep = immBrokerRightsCashExchange.get('visibleStep');
        const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
        const bookletLabel = (
            <OKLink modifier="emphasize" to={immBrokerRightsCashExchange.getIn(['selectedOperation','linkTriptico'])} target="_blank">
                <FormattedText value="brokerSubscription-informativeMessageBookletLabel"/>
            </OKLink>
        );
        const CNMVLabel = (
            <OKLink modifier="emphasize" to={immBrokerRightsCashExchange.getIn(['selectedOperation','linkCNMV'])} target="_blank">
                <FormattedText value="brokerSubscription-informativeMessageCNMVLabel"/>
            </OKLink>
        );
        const legalConfirmation = __CONTACT_CENTER__ ? this.builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) : null;
        let ccStep;
        const actions = {
            cancel: onCancel,
            finish: onFinish,
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        if (__CONTACT_CENTER__) {
            const nextButtonEnabled = immBrokerRightsCashExchange.get('selectedLegalConfirmation') == SELECTED_VALUES.YES;
            ccStep = (
                <WizardStep
                    nextButtonDisabled={!nextButtonEnabled}
                    actions={actions}
                    position={"first"}
                    cancelButton={true}
                >
                    {legalConfirmation}
                </WizardStep>
            )
            const firstStep = Immutable.fromJS({
                    valid: immBrokerRightsCashExchange.get('validLegalConfirmation'),
            });
            immSteps = immSteps.unshift(firstStep);
        }

        const stepsAmount = immSteps.size;
        const wizard = __CONTACT_CENTER__ ? (
            <div className="col-xs-8">
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                >
                    {ccStep}
                    <WizardStep
                        position={__CONTACT_CENTER__? "middle":"first"}
                        cancelButton={true}
                        isLoading={firstStepIsLoading} >
                        <BrokerRightsCashExchangeStep1
                            immStep1={immStep1}
                            onChangeRightsQuantity={onChangeRightsQuantity}/>
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        cancelButton={true}
                        immFinalButton="brokerRightsCashExchange-brokerRightsCashExchange_step2FinalButton"
                        isLoading={loading}
                        position="last" >
                        <BrokerRightsCashExchangeStep2
                            immSelectedContract={immSelectedContract}
                            immBrokerRightsCashExchange={immBrokerRightsCashExchange}
                            onChangeManifest={onChangeManifest} />
                    </WizardStep>
                </Wizard>
            </div>
        ) : (
            <div className="col-xs-8">
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                >
                    <WizardStep
                        position="first"
                        cancelButton={true}
                        isLoading={firstStepIsLoading} >
                        <BrokerRightsCashExchangeStep1
                            immStep1={immStep1}
                            onChangeRightsQuantity={onChangeRightsQuantity}/>
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        cancelButton={true}
                        immFinalButton="brokerRightsCashExchange-brokerRightsCashExchange_step2FinalButton"
                        isLoading={loading}
                        position="last" >
                        <BrokerRightsCashExchangeStep2
                            immSelectedContract={immSelectedContract}
                            immBrokerRightsCashExchange={immBrokerRightsCashExchange}
                            onChangeManifest={onChangeManifest}
                            setDocumentsRead={setDocumentsRead} />
                    </WizardStep>
                </Wizard>
            </div>
        )
        return wizard;
    }

    buildSidebar() {
        const { immBrokerRightsCashExchange, immProductFile } = this.props;
        const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
        const immSelectedOperation = immBrokerRightsCashExchange.get('selectedOperation');
        const titles = immBrokerRightsCashExchange.getIn(['steps', FIRST_STEP , 'rightsQuantity'])
        return (
            <div className="col-xs-4" id="printable-wizard">
                <BrokerRightsCashExchangeSidebar
                    immProductFile={immProductFile}
                    titles={titles}
                    immSelectedContract={immSelectedContract}
                    immSelectedOperation={immSelectedOperation}/>
            </div>
        );
    }

    buildSuccess() {
        const { immBrokerRightsCashExchange } = this.props;
        return (
            <BrokerRightsCashExchangeSucess
                immBrokerRightsCashExchange={immBrokerRightsCashExchange} />
        );
    }

    buildContent() {
        const { immBrokerRightsCashExchange } = this.props;
        const confirmationSuccess = immBrokerRightsCashExchange.get('submitSucessful');
        let content;
        if(confirmationSuccess) {
            content = (
                <div className="row">
                    {this.buildSuccess()}
                </div>
            );
        } else {
            content = (
                <div className="row">
                    {this.buildWizard()}
                    {this.buildSidebar()}
                </div>
            );
        }

        return content;
    }

    render() {
        return (
            <div className="broker-rights-cash-exchange__main-container row no-outside-gutter">
                {this.buildContent()}
            </div>
        );
    }
}

BrokerRightsCashExchange.propTypes = {
    immProfileFields: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    immCorporatesOperations: PropTypes.object,
    currency: PropTypes.string,
    sendPreContractualMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    requestProfile: PropTypes.func,
    immBrokerRightsCashExchange: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    onChangeRightsQuantity: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    selectedLegalConfirmationValue: PropTypes.string,
    setVisibleStep: PropTypes.func.isRequired,
    setLegalOptionChange: PropTypes.func,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
}

module.exports = BrokerRightsCashExchange;
